import React from 'react';

function Header() {
  return (
    
    
    <header className="header bg">
        <div className="container text-white">
            <div className="row">
                <div className="col-sm-4 align-self-center text-left">
                    
                    <a href="http://www.ufpi.br" target="_blank" rel="noreferrer"> <img src='/images/logo_ufpi.jpg' width="200"></img> </a>
                </div>
                <div className="col-sm-4 col-12 align-self-center box-1 text-center">
                    <a className="navbar-brand" href="index.html"><img src="images/header-logo.png" alt="logo" /></a>
                </div>
                <div className="col-sm-4 align-self-center text-right">
                    <div className="social-icons">
                        <a href="http://www.facebook.com"><i className="fa fa-facebook-official" aria-hidden="true"></i> </a>
                        <a href="http://www.twitter.com"><i className="fa fa-twitter" aria-hidden="true"></i> </a>
                        <a href="http://www.pinterest.com"><i className="fa fa-pinterest" aria-hidden="true"></i> </a>
                        <a href="http://www.youtube.com"><i className="fa fa-youtube" aria-hidden="true"></i> </a> <br/><br/>
                        <h6>Desde 2012</h6>
                    </div>
                    <div>
                    
                    </div>
                </div>
            </div>
          
        </div>
    
    </header>

    
    
  );
}

export default Header;
